import React from 'react';

import {useUnit} from 'effector-react';
import {HelmetProvider} from 'react-helmet-async';
import {Redirect, Route, Router, Switch} from 'react-router-dom';

import {ToastContainer} from 'react-toastify';

import {PRIVATE_ROUTES_DATA, PUBLIC_ROUTES_DATA} from '@app/routing/config';
import {ROUTES} from '@app/routing/routes';
import {PrivateRoute} from '@app/routing/ui/PrivateRoute';
import {userModel} from '@entities/user/model';
import {useUserPermissions} from '@entities/user/permissions';
import {Account} from '@features/Account';
import {NotFoundPage} from '@pages/NotFound';
import {history} from '@shared/lib/history';
import {MainLayout} from '@shared/ui/Layout/default';

export * from './routes';
export * from './config';

export const Routing = () => {
    const user = useUnit(userModel);
    const {asideItems, defaultPrivateRoute, profilePath} = useUserPermissions();

    const Logo = {
        small: <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" />,
        full: (
            <div style={{display: 'flex', gap: 8, alignItems: 'flex-start'}}>
                <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" />
                <span style={{fontSize: 21}}>traceCORE</span>
            </div>
        ),
    };

    return (
        <Router history={history}>
            <HelmetProvider>
                <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar
                    closeOnClick
                />
                <Switch>
                    {Object.entries(PUBLIC_ROUTES_DATA).map(([path, {component, ...props}]) => (
                        <Route key={path} path={path} exact={props.exact}>
                            {component}
                        </Route>
                    ))}

                    {Object.entries(PRIVATE_ROUTES_DATA).map(([path, {component, ...props}]) => (
                        <PrivateRoute key={path} path={path} {...props}>
                            <MainLayout
                                asideItems={asideItems}
                                profilePath={profilePath}
                                headerSlot={<Account />}
                                logoSlot={Logo}
                            >
                                {component}
                            </MainLayout>
                        </PrivateRoute>
                    ))}

                    <Route path="/" exact>
                        <Redirect to={user.state.isAuth ? defaultPrivateRoute : ROUTES.LOGIN} />
                    </Route>

                    <Route path="*">
                        <NotFoundPage />
                    </Route>
                </Switch>
            </HelmetProvider>
        </Router>
    );
};
